import moment from "moment-timezone";

export const formatDate = (date: string) => {
  if (!date) return date;
  return moment(parseInt(date)).format("M/D/YYYY h:m A");
};
